/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { SystemEventName, SystemEventStatus, SystemEventType } from "../enums";
export const systemEventSchema = z.object({
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  name: z.nativeEnum(SystemEventName),
  status: z.nativeEnum(SystemEventStatus).nullish(),
  type: z.nativeEnum(SystemEventType),
  updatedAt: z.string().datetime().nullish(),
  value: 
    z.object({
      error: z.string().nullish(),
      message: z.string().nullish(),
      version: z.string().nullish(),
    })
  .nullish(),
});

export type SystemEvent = z.infer<typeof systemEventSchema>;
